module.exports = MaterialUI.Icon;